import React from 'react';
import { Navigate } from 'react-router-dom';
import LiveCouponPoster from '../components/LiveCouponPoster';
import { useAuth } from '../context/AuthContext';
import { useLiveCoupon } from '../hooks/useLiveCoupon';

const LIVE_COUPON_SEEN_KEY = 'liveCouponSeenAt';

const LiveCouponPage = () => {
  const { isAdmin } = useAuth();
  const { coupon, visible, enabled, loading, error } = useLiveCoupon();

  React.useEffect(() => {
    if (coupon?.generatedAt) {
      localStorage.setItem(LIVE_COUPON_SEEN_KEY, coupon.generatedAt);
    }
  }, [coupon?.generatedAt]);

  if (loading) return <div className="loading">Canli kupon hazirlaniyor...</div>;
  if (error) return <div className="error">{error}</div>;
  if (!visible && !isAdmin) return <Navigate to="/" replace />;

  return (
    <div className="page analysis-page">
      <section className="hero-panel compact premium-coupon-hero live-coupon-hero">
        <div className="hero-copy">
          <span className="hero-badge premium-hero-badge">Canli Kupon</span>
          <h1 className="live-hero-title">CANLI KUPON VITRINI</h1>
          <p>
            Sadece buyuk ligler, yuksek veri kalitesi ve cok guclu canli sinyal gecen en fazla 2 mac burada poster halinde gosterilir.
          </p>
        </div>
      </section>

      {coupon ? (
        <section className="content-panel">
          <LiveCouponPoster coupon={coupon} adminHidden={isAdmin && !enabled} />
        </section>
      ) : (
        <div className="empty">
          {isAdmin && !enabled
            ? 'Canli kupon admin tarafinda kapali. Acildiginda premium kullanicilar gorebilir.'
            : 'Su an kurallari gecen canli kupon bulunmuyor.'}
        </div>
      )}
    </div>
  );
};

export default LiveCouponPage;
